import React from 'react';
import { Link } from "react-router-dom";

const FooterTwo = () => {
    const year = new Date().getFullYear();
    return (
        <div className="footer-style-2 ptb--30 bg_image bg_image--3">
            <div className="wrapper plr--50 plr_sm--20">
                <div className="row align-items-center justify-content-between">
                    <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                        <div className="inner">
                            <div className="logo text-center text-sm-left mb_sm--20">
                                <Link to="/">
                                    <img src="/assets/images/portfolio/tmfavicon2.png" alt="Logo images" height="50px" />
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                        <div className="inner text-center">
                            <div className="text">
                                <p>Copyright © {year} Theo Mefford. All Rights Reserved.</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-12 col-sm-12 col-12">
                        <div className="inner text-lg-right text-center mt_md--20 mt_sm--20 ">
                            <div className="text">
                                <h5>
                                    <Link to="/contact">Get in touch</Link>
                                </h5>
                                <h5>San Francisco, CA</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default FooterTwo;
